import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

const useKlydoDeleteCount = (klydoId: string, enabled: boolean) => {
  return useQuery<{ deleted: number }>({
    queryKey: ["klydoDeleteCount", klydoId],
    queryFn: () => adminApiClient.getKlydoDeleteCount(klydoId),
    enabled,
  });
};

export default useKlydoDeleteCount;
